import { render, staticRenderFns } from "./EcommerceCheckout.vue?vue&type=template&id=2c22df45&scoped=true"
import script from "./EcommerceCheckout.vue?vue&type=script&lang=js"
export * from "./EcommerceCheckout.vue?vue&type=script&lang=js"
import style0 from "./EcommerceCheckout.vue?vue&type=style&index=0&id=2c22df45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c22df45",
  null
  
)

export default component.exports